import React from 'react';
import { DatePicker, Button, Checkbox, Carousel, Menu, Icon, Modal } from 'antd'
// require('./ParticleEffect.js')
// import Particles from 'reactparticles.js';
import Particles from 'react-particles-js';
import { Get, wrapResponse } from './../../../requst'
require('./banner.scss')
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;
export default class Banner extends React.Component {
	static async getInitialProps(ctx) {
		const data = await wrapResponse(Get({ url: 'base/banner' }))
		return { data }
	}

	constructor(props, context) {
		super(props, context)
		this.goConsulting = this.goConsulting.bind(this);
		this.state = {
		}

	}

	banner() {
		return this.props.data.map((item, index) => (
			<div key={index} className='AAAAA'>
				<div style={{ flex: '1' }}>
					<div style={{ maxWidth: '466px', height: '465px', color: '#fff', paddingTop: '120px', margin: '0 auto' }}>
						<div style={{ display: 'inline-block' }}>
							<p className="BannerText" style={{ fontSize: '36px' }}>{item.desc}</p>

						</div>
						<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '60px' }}>
							<a href="/caseshow" className="bannerBtn" style={{ width: '150px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #eee', borderRadius: '3px', cursor: 'pointer' }}>查看案例</a>
							{/* <div className="bannerBtn" style={{width:'150px',height:'50px',display:'flex',justifyContent:'center',alignItems:'center',border:'1px solid #eee',borderRadius:'3px',cursor:'pointer'}} onClick={this.goConsulting}>立即咨询</div> */}
						</div>
					</div>
				</div>
				<div style={{ flex: '1' }}>
					<img style={{ maxWidth: '562px', maxHeight: '466px' }} src={item.photos} alt="" />
				</div>
			</div>
		))
	}
	goConsulting() {
		this.setState({
			visible: true,
		});
	}
	handleOk(e) {
		// console.log(e);
		this.setState({
			visible: false,
		});
	}
	handleCancel(e) {
		// console.log(e);
		this.setState({
			visible: false,
		});
	}
	render() {
		// console.log(this.props)
		return (
			<div style={{ background: '#161893', position: 'relative', height: '580px', overflow: 'hidden' }}>
				<Particles
					params={{
						"particles": {
							"number": {
								"value": 200
							},
							"size": {
								"value": 3
							}
						},
						"interactivity": {
							"events": {
								"onhover": {
									"enable": true,
									"mode": "repulse"
								}
							}
						}
					}} />
				<div style={{ position: 'absolute', zIndex: '200', width: '100%', top: '0' }}>
					<div style={{ height: '80px' }}></div>
					<Carousel autoplay >
						{/*autoplay*/}
						{this.props.data && this.props.data.length ? this.banner() : null}


					</Carousel>
				</div>
			</div>

		)
	}


}
